import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    fill: 'none',
  },
}));

export default useStyles;
